import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Rotas } from './Router.tsx'
import './shared/theme/index.ts'
import './shared/i18n/i18n.ts'
import { AuthProvider } from './shared/contexts/AuthContext.tsx'
import 'bootstrap/dist/css/bootstrap.min.css';
import { CondominiumProvider } from './shared/contexts/CondominioContext.tsx'
import { BuildingProvider } from './shared/contexts/BuidingContext.tsx'
import { NotificationProvider } from './shared/contexts/NotificationContext.tsx'
import { isPlatformAdminHost } from './config.ts'
import PlatformAdminRoot from './features/platform-admin/PlatformAdminRoot.tsx'

// admin.<dominio-raiz> serve o painel de administração da plataforma: uma
// árvore de app à parte, sem os providers nem as rotas da app normal.
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {isPlatformAdminHost() ? (
      <PlatformAdminRoot />
    ) : (
      <AuthProvider>
        <CondominiumProvider>
          <NotificationProvider>
            <BuildingProvider>
              <Rotas />
            </BuildingProvider>
          </NotificationProvider>
        </CondominiumProvider>
      </AuthProvider>
    )}
  </StrictMode>,
)
